import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import * as api from "./api";
import type { RequestFilter } from "./api";

const listKey = (filter: RequestFilter) =>
  ["portal", "requests", filter.status || "all"] as const;

export function useRequests(filter: RequestFilter) {
  return useInfiniteQuery({
    queryKey: listKey(filter),
    queryFn: ({ pageParam }) => api.listRequests(filter, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.meta.next ?? undefined,
  });
}

export const useAssignableStaff = () =>
  useQuery({
    queryKey: ["portal", "requests-assignable-staff"],
    queryFn: api.listAssignableStaff,
  });

// Toda mutación invalida las cuatro variantes de filtro (all + los tres
// estados no cerrados): la bandeja abre en "nuevas" pero un operador puede
// tener otra pestaña de estado abierta cuando otro cambia una solicitud.
export function useRequestMutations() {
  const client = useQueryClient();
  const invalidate = () =>
    client.invalidateQueries({ queryKey: ["portal", "requests"] });
  return {
    assign: useMutation({
      mutationFn: ({ id, assignedTo }: { id: string; assignedTo: string }) =>
        api.assignRequest(id, assignedTo),
      onSuccess: invalidate,
    }),
    contact: useMutation({
      mutationFn: (id: string) => api.contactRequest(id),
      onSuccess: invalidate,
    }),
    close: useMutation({
      mutationFn: ({ id, note }: { id: string; note: string }) =>
        api.closeRequest(id, note),
      onSuccess: invalidate,
    }),
  };
}
